export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20layered%20translucent%20shapes%20in%20warm%20terracotta%20and%20sand%20tones%2C%20subtle%20grid%20patterns%2C%20modern%20architectural%20minimalist%20design%2C%20soft%20diffused%20gradients%2C%20clean%20editorial%20aesthetic%2C%20no%20text%20no%20people%2C%20warm%20atmospheric%20lighting%2C%20abstract%20digital%20texture%2C%20high%20resolution%20fine%20art%20quality&width=1800&height=1000&seq=hero-bg-tubi-2026&orientation=landscape"
        alt="Abstract geometric composition representing modern software engineering"
        title="TubiConsult AB engineering excellence"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-8">
            <span className="block w-8 h-px bg-white/40" />
            <span className="w-1.5 h-1.5 rounded-full bg-white/60" />
            <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
            <span className="block w-8 h-px bg-white/40" />
          </div>

          <h2 className="text-4xl md:text-6xl lg:text-7xl font-light text-white leading-tight tracking-tight">
            Engineering the
            <br />
            <span className="font-semibold">future of software</span>
          </h2>

          <p className="mt-8 text-base md:text-lg text-white/70 max-w-xl mx-auto leading-relaxed">
            A professional engineering team focused on designing and developing
            modern digital software solutions built for reliability, scale, and
            long-term technical excellence.
          </p>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-white/30 rounded-full flex items-start justify-center p-1">
          <span className="block w-1 h-2 bg-white/50 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}